import React from 'react';
import { Users } from 'lucide-react';

const PartnerIntegration = () => {
  const partners = [
    { name: 'Firebase', logo: '🔥' },
    { name: 'Google Cloud', logo: '☁️' },
    { name: 'Azure', logo: '⊿' },
    { name: 'Oracle', logo: 'ORACLE' },
    { name: 'Salesforce', logo: '☁' },
    { name: 'SendGrid', logo: '📧' },
    { name: 'AWS', logo: 'aws' },
    { name: 'Firebase', logo: '🔥' }
  ];

  return (
    <div className="w-full bg-gradient-to-b from-gray-50 to-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
            <div className="bg-orange-100 rounded-full p-3">
              <Users className="w-6 h-6 text-orange-600" />
            </div>
            <h2 className="text-3xl md:text-4xl xl:text-5xl font-bold text-gray-900">
              Partner With <span className="text-orange-600">KGS TECHNOLOGY</span>
            </h2>
          </div>
          
          <p className="text-gray-600 text-lg md:text-xl max-w-4xl mx-auto leading-relaxed">
            Partner with us to deliver seamless integration, real-time execution
            visibility, and measurable supply chain performance powered by 50+ ready-
            to-deploy connectors.
          </p>
        </div>

        {/* Partner Logos Carousel */}
        <div className="relative overflow-hidden">
          <div className="flex items-center gap-12 animate-scroll">
            {/* First set of logos */}
            <div className="flex items-center justify-center min-w-[200px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <div className="flex items-center gap-2">
                <span className="text-3xl">🔥</span>
                <span className="text-xl font-semibold text-gray-700">Firebase</span>
              </div>
            </div>

            <div className="flex items-center justify-center min-w-[220px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <img 
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 272 92'%3E%3Ctext x='0' y='60' font-family='Arial' font-size='48' fill='%234285F4'%3EGoogle Cloud%3C/text%3E%3C/svg%3E" 
                alt="Google Cloud" 
                className="h-8"
                onError={(e) => e.target.style.display = 'none'}
              />
              <span className="text-xl font-semibold text-gray-700">Google Cloud</span>
            </div>

            <div className="flex items-center justify-center min-w-[200px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <div className="flex items-center gap-3">
                <svg className="w-10 h-10" viewBox="0 0 24 24" fill="#0078D4">
                  <path d="M22.379 23.343a1.62 1.62 0 0 0 1.536-2.14v.002L17.35 1.76A1.62 1.62 0 0 0 15.816.657L8.85 2.858a1.62 1.62 0 0 0-1.099 1.52L6.95 4.38 3.414 5.408a1.62 1.62 0 0 0-1.099 1.52v11.552a1.62 1.62 0 0 0 1.098 1.538l6.965 2.202a1.62 1.62 0 0 0 1.536-.002l6.965-2.2a1.62 1.62 0 0 0 1.098-1.537v-6.963l2.512-.794v6.756z"/>
                </svg>
                <span className="text-xl font-semibold text-gray-700">Azure</span>
              </div>
            </div>

            <div className="flex items-center justify-center min-w-[200px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <span className="text-2xl font-bold text-red-600">ORACLE</span>
            </div>

            <div className="flex items-center justify-center min-w-[220px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <div className="flex items-center gap-2">
                <svg className="w-10 h-10" viewBox="0 0 24 24" fill="#00A1E0">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 14.47c0 2.034-1.65 3.684-3.684 3.684H9.79c-2.034 0-3.684-1.65-3.684-3.684V9.053c0-.17.138-.308.308-.308h1.368c.17 0 .308.138.308.308v5.417c0 1.034.84 1.874 1.874 1.874h4.42c1.034 0 1.874-.84 1.874-1.874V9.053c0-.17.138-.308.308-.308h1.368c.17 0 .308.138.308.308v5.417z"/>
                </svg>
                <span className="text-xl font-bold text-gray-700">Salesforce</span>
              </div>
            </div>

            <div className="flex items-center justify-center min-w-[200px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <div className="flex items-center gap-3">
                <svg className="w-8 h-8" viewBox="0 0 24 24" fill="#1A82E2">
                  <rect x="2" y="6" width="20" height="12" rx="2" fill="#1A82E2"/>
                  <path d="M2 8h20M6 12h8" stroke="white" strokeWidth="1.5"/>
                </svg>
                <span className="text-xl font-bold text-gray-700">SendGrid</span>
              </div>
            </div>

            <div className="flex items-center justify-center min-w-[180px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <span className="text-2xl font-bold text-gray-800">aws</span>
            </div>

            <div className="flex items-center justify-center min-w-[200px] h-24 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 px-8">
              <div className="flex items-center gap-2">
                <span className="text-3xl">🔥</span>
                <span className="text-xl font-semibold text-gray-700">Firebase</span>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        {/* <div className="text-center mt-16">
          <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            Explore All Connectors
          </button>
        </div> */}
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 30s linear infinite;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default PartnerIntegration;